{
  "home": {
    "pageTitle": "DEC Energy | Energy-Fintech for the Energy Transition",
    "description": "Energy-fintech solutions redefining how renewable energy is produced and consumed. Discover DEC Energy for companies and producers.",
    "ogTitle": "DEC Energy - Energy-Fintech for the Energy Transition",
    "ogDescription": "Energy-fintech solutions redefining how renewable energy is produced and consumed. Discover DEC Energy for companies and producers."
  },
  "company": {
    "pageTitle": "Cut Energy Costs with Guarantees of Origin | DEC Energy",
    "description": "Turn renewable procurement into profit: produce your own Guarantees of Origin from selected plants and cut energy costs predictably.",
    "ogTitle": "Cut Energy Costs - DEC Energy",
    "ogDescription": "Turn renewable procurement into profit: produce your own Guarantees of Origin from selected plants and cut energy costs predictably."
  },
  "companyCalendly": {
    "pageTitle": "Book an Appointment - Companies | DEC Energy",
    "description": "Book an appointment to discover how to make your Guarantees of Origin consumption profitable",
    "ogTitle": "Book a Meeting - DEC Energy",
    "ogDescription": "Book an appointment to discover how to make your Guarantees of Origin consumption profitable"
  },
  "companyEnergyManager": {
    "pageTitle": "For Energy Managers | DEC Energy",
    "description": "Make renewable energy procurement profitable",
    "ogTitle": "Energy Manager - DEC Energy",
        "ogDescription": "Make renewable energy procurement profitable"
  },
  "companyProduct": {
    "pageTitle": "The DEC Energy Model for Companies | DEC Energy",
    "description": "Contract photovoltaic plants to produce your Guarantees of Origin and profits",
    "ogTitle": "Our Product for Companies - DEC Energy",
        "ogDescription": "Contract photovoltaic plants to produce your Guarantees of Origin and profits"
  },
  "companySustainabilityManager": {
    "pageTitle": "For Sustainability Managers | DEC Energy",
    "description": "Contribute to the energy transition with real and communicable impact",
    "ogTitle": "Sustainability Manager - DEC Energy",
        "ogDescription": "Contribute to the energy transition with real and communicable impact"
  },
  "producer": {
    "pageTitle": "For Producers | DEC Energy",
    "description": "Receive upfront cash on your plants and derisk prices and production",
    "ogTitle": "For Producers - DEC Energy",
        "ogDescription": "Receive upfront cash on your plants and derisk prices and production"
  },
  "producerCalendly": {
    "pageTitle": "Book an Appointment - Producers | DEC Energy",
    "description": "Book an appointment to discover how to receive upfront cash from your plants",
    "ogTitle": "Book a Meeting - DEC Energy",
        "ogDescription": "Book an appointment to discover how to receive upfront cash from your plants"
  },
  "producerIpps": {
    "pageTitle": "For Independent Producers | DEC Energy",
    "description": "Unlock the full potential of your capital and grow your asset portfolio",
    "ogTitle": "IPPs - DEC Energy",
        "ogDescription": "Unlock the full potential of your capital and grow your asset portfolio"
  },
  "producerProduct": {
    "pageTitle": "The DEC Energy Model for Producers | DEC Energy",
    "description": "Receive upfront cash and derisking on your assets",
    "ogTitle": "Our Product for Producers - DEC Energy",
        "ogDescription": "Receive upfront cash and derisking on your assets"
  },
  "producerUtility": {
    "pageTitle": "For Utilities | DEC Energy",
    "description": "Accelerate your energy transition while maintaining ownership of your plants",
    "ogTitle": "Utility - DEC Energy",
        "ogDescription": "Accelerate your energy transition while maintaining ownership of your plants"
  },
  "contactForm": {
    "pageTitle": "Contact Our Experts | DEC Energy",
    "description": "Fill out the form to be contacted by one of our experts",
    "ogTitle": "Contact Us - DEC Energy",
        "ogDescription": "Fill out the form to be contacted by one of our experts"
  },
  "aboutUs": {
    "pageTitle": "About Us | DEC Energy",
    "description": "Discover how at DEC Energy we are building fintech tools that redefine renewable energy production and consumption",
    "ogTitle": "About Us - DEC Energy",
        "ogDescription": "Discover how at DEC Energy we are building fintech tools that redefine renewable energy production and consumption"
  },
  "blog": {
    "pageTitle": "DEC Insights | DEC Energy",
    "description": "Read our articles on renewable energy, sustainability, and the latest industry news.",
    "ogTitle": "Blog - DEC Energy",
        "ogDescription": "Read our articles on renewable energy, sustainability, and the latest industry news."
  },
  "decExplorer": {
    "pageTitle": "DEC Explorer | DEC Energy",
    "description": "Quantify your savings by adopting the DEC Energy model",
    "ogTitle": "DEC Explorer - DEC Energy",
        "ogDescription": "Quantify your savings by adopting the DEC Energy model"
  },
  "faq": {
    "pageTitle": "FAQ | DEC Energy",
    "description": "Find all the answers to frequently asked questions",
    "ogTitle": "FAQ - DEC Energy",
    "ogDescription": "Find all the answers to frequently asked questions"
  },
  "producerIppLight": {
    "pageTitle": "IPP Light | DEC Energy",
    "description": "DEC Energy's solution for small renewable energy producers",
    "ogTitle": "IPP Light - DEC Energy",
    "ogDescription": "DEC Energy's solution for small renewable energy producers"
  },
  "solutionRiduzione": {
    "pageTitle": "Predictable Energy Cost Reduction | DEC Energy",
    "description": "Further reduce your energy costs predictably with DEC Energy",
    "ogTitle": "Predictable Reduction - DEC Energy",
    "ogDescription": "Further reduce your energy costs predictably with DEC Energy"
  },
  "solutionConformita": {
    "pageTitle": "Future-Proof Compliance | DEC Energy",
    "description": "Turn the cost of compliance into recurring operating revenue with DEC Energy",
    "ogTitle": "Compliance - DEC Energy",
    "ogDescription": "Turn the cost of compliance into recurring operating revenue with DEC Energy"
  },
  "solutionEbitda": {
    "pageTitle": "Improve EBITDA | DEC Energy",
    "description": "Improve your operational profitability with the DEC Energy solution",
    "ogTitle": "EBITDA - DEC Energy",
    "ogDescription": "Improve your operational profitability with the DEC Energy solution"
  },
  "solutionCoperturaNaturale": {
    "pageTitle": "Natural Cost Coverage | DEC Energy",
    "description": "Neutralize your energy cost fluctuations for the next 10 years",
    "ogTitle": "Natural Coverage - DEC Energy",
    "ogDescription": "Neutralize your energy cost fluctuations for the next 10 years"
  },
  "solutionImpatto": {
    "pageTitle": "Sustainable Impact | DEC Energy",
    "description": "Elevate your energy transition with a concrete and communicable solution",
    "ogTitle": "Impact - DEC Energy",
    "ogDescription": "Elevate your energy transition with a concrete and communicable solution"
  },
  "capital": {
    "pageTitle": "DEC Capital, Revenue Shares in Renewable Plants | DEC Energy",
    "description": "Revenue shares in renewable plants already operating in Italy: real-asset returns and contractual protection, without buying the assets.",
    "ogTitle": "DEC Capital - DEC Energy",
    "ogDescription": "Revenue shares in renewable plants already operating in Italy: real-asset returns and contractual protection, without buying the assets."
  },
  "notFound": {
    "pageTitle": "Page not found | DEC Energy",
    "description": "The page you are looking for does not exist. Go back to the DEC Energy home page or write to us.",
    "ogTitle": "Page not found - DEC Energy",
    "ogDescription": "The page you are looking for does not exist. Go back to the DEC Energy home page or write to us."
  },
  "publicProfile": {
    "pageTitle": "Public profile | DEC Energy",
    "description": "A company's public profile on DEC Energy: its plants, production and the impact of its renewable energy.",
    "ogTitle": "Public profile - DEC Energy",
    "ogDescription": "A company's public profile on DEC Energy: its plants, production and the impact of its renewable energy."
  }
}
